import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/siding-repair")({
  beforeLoad: () => {
    throw redirect({ to: "/services/siding-repair", statusCode: 301 });
  },
});
